export const COMMERCETOOLS_ATTRIBUTES = {
  SET_ITEMS: "setItems",
  PRODUCT_SET_LINE_QUANTITY: "productSetLineQty",
};
